import { useEffect } from 'react';
import { useAuth } from '@front-activerse/common-components';
import { ignoreErrors } from '@front-activerse/common-components';

import { useApolloClient } from '@apollo/client';
import { UserDataQuery, formatIsoDate } from '@front-activerse/common-components';

import analytics from './Firebase/firebaseAnalytics';
import { setUserId } from 'firebase/analytics';

import * as Sentry from '@sentry/react';
import { SENTRY_DSN, APP_VERSION } from './consts';

import { withMobileAppMode } from '@front-activerse/common-components';

const SetupApp = ({ mobileAppMode }) => {
  const client = useApolloClient();
  const isAuth = useAuth();

  useEffect(() => {
    setupSentry();
  }, []);

  useEffect(() => {
    setupErrorReportingContext();
    setupFirebaseUserID();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth]);

  const setupSentry = () => {
    Sentry.init({
      dsn: SENTRY_DSN,
      release: APP_VERSION,
      environment: import.meta.env.VITE_REACT_APP_ENV,
      denyUrls: [/tiktok\.com/i, /facebook\.com/i, /googletagmanager\.com/i, /analytics\.js/i],
      ignoreErrors: ignoreErrors,
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
    });
  };

  const setupErrorReportingContext = () => {
    let id;
    let email;
    let name;

    if (isAuth) {
      const userData = client.readQuery({
        query: UserDataQuery,
        variables: { date: formatIsoDate(new Date()) },
      });

      if (userData && userData.me && userData.me.id) {
        id = userData.me.id;
        name = userData.me.name;
        email = userData.me.email;

        Sentry.setUser({
          id,
          email,
          username: name,
        });
      }
    }

    Sentry.setContext('mobileAppMode', mobileAppMode);
  };

  const setupFirebaseUserID = () => {
    let id = `fakeUserId_${new Date().getTime()}`;

    if (isAuth) {
      const userData = client.readQuery({
        query: UserDataQuery,
        variables: { date: formatIsoDate(new Date()) },
      });

      if (userData && userData.me && userData.me.id) {
        id = userData.me.id;
      }
    }
    setUserId(analytics, `${id}`);
  };

  return null;
};

export default withMobileAppMode(SetupApp);
